import { render, staticRenderFns } from "./recommendation-items.vue?vue&type=template&id=c8b59cea&scoped=true"
import script from "./recommendation-items.vue?vue&type=script&lang=js"
export * from "./recommendation-items.vue?vue&type=script&lang=js"
import style0 from "./recommendation-items.vue?vue&type=style&index=0&id=c8b59cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b59cea",
  null
  
)

export default component.exports